import { redirect } from '@tanstack/react-router';
import { PLATFORM, ROLES, type Platform } from '@/shared/constants';
import { readCookie } from './cookies';
import { canActivate, getUserProfile, logout } from './session';

/**
 * Route guard: unauthenticated users are logged out (storage cleared)
 * and sent to /login.
 *
 * Dev only: the Vite server (:3001) and Express (:3000) are two origins with
 * separate localStorage, but the `token` cookie dropped by the API is shared
 * by every port of localhost. When the session is missing here but the cookie
 * exists, /ad_auth rebuilds it instead of bouncing to /login. Never in
 * production: after an explicit logout the cookie may still exist, and a
 * silent re-login would be a behaviour change.
 */
export const requireAuth = (): void => {
  if (canActivate()) return;
  if (import.meta.env.DEV && readCookie('token')) {
    throw redirect({ to: '/ad_auth' });
  }
  logout();
  throw redirect({ to: '/login' });
};

/**
 * Route guard: only allows access to users with the admin role.
 */
export const requireAdmin = (platform: Platform) => (): void => {
  requireAuth();
  if (getUserProfile()?.role !== ROLES.ADMIN) {
    throw redirect({
      to: platform === PLATFORM.DMS ? '/mtm/main' : '/main',
    });
  }
};
